module.exports = __webpack_public_path__ + "media/images/faces/male/03-6d213e95899dcc2887338c264c68cec3.jpg";